<template>
    <tr>
        <td class="text-center">
            <span class="ix-drag-icon handle-line"></span>
        </td>
        <td>
            <input class="form-control form-control-sm" type="text" :name="'providers[' + index + '][company_name]'" v-model="provider.company_name" @input="emitEeventLineEdited" :id="'companyAutocomplete' + provider.uniq">
            <input type="hidden" :name="'providers[' + index + '][id]'" v-model="provider.id">
            <input type="hidden" :name="'providers[' + index + '][index]'" v-model="index">
            <input type="hidden" :name="'providers[' + index + '][company_id]'" v-model="provider.company_id">
        </td>
        <td>
            <input type="text" class="form-control form-control-sm" :name="'providers[' + index + '][reference]'" v-model="provider.reference">
        </td>
        <td>
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-right" :name="'providers[' + index + '][amount]'" v-model="provider.amount" :required="provider.company_name != ''" step="0.01">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                </div>
            </div>
        </td>
        <td>
            <div class="input-group">
                <input type="text" class="form-control form-control-sm" :name="'providers[' + index + '][ean]'" v-model="provider.ean" :id="'ean'+index">
                <div class="input-group-append">
                    <button class="ix-btn ix-btn-icon blue barcode-trigger" type="button" :data-target-input-id="'ean' + index">
                        <i class="far fa-barcode-read"></i>
                    </button>
                </div>
            </div>
        </td>
        <td>
            <input type="text" class="form-control form-control-sm" :name="'providers[' + index + '][description]'" v-model="provider.description">
        </td>
        <td class="text-center">
            <input type="checkbox" v-model="provider.is_favorite" :name="'providers[' + index + '][is_favorite]'" value="1" @change="favoriteChange($event)">
        </td>
        <td class="text-right">
            <span class="btn btn-sm transparent" @click="emitEventLineDeleted">
                <i class="far fa-trash"></i>
            </span>
        </td>
    </tr>
</template>

<script>
    import $ from 'jquery'
    import Swal from "sweetalert2";

    export default {
        name: 'article-provider-form',
        props: ['provider', 'index', 'companiesRoute'],
        data() {
            return {
                errors: [],
            };
        },
        methods : {
            favoriteChange: function (e) {
                if (this.provider.is_favorite) {
                    this.$emit('provider-favorited', this.index)
                }
            },
            emitEeventLineEdited: function () {
                this.$emit('provider-editing-started', this.index)
            },
            emitEventLineDeleted: function () {
                Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, supprimer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.$emit('provider-deleted', this.index)
                    }
                })
            }
        },
        mounted() {
            $("#companyAutocomplete" + this.provider.uniq).autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.companiesRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.name,
                                    value: item.name,
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        this.provider.company_id = null
                    }
                },
                select: (e, item) => {
                    this.provider.company_id = item.item.id
                    this.provider.company_name = item.item.name
                }
            }).focus(() => {
                $("#companyAutocomplete" + this.provider.uniq).autocomplete("search", '');
            });
        }
    }
</script>
